import { PageId } from 'constants/pages'

export const enum PageIdIntlD60 {
  OFFER = PageId.OFFER_INTL_D60,
  PAYMENT = PageId.PAYMENT_INTL_D60,
  CHECKOUT = PageId.CHECKOUT_INTL_D60,
  UPSELL = PageId.UPSELL_INTL_D60,
  REGISTRATION = PageId.REGISTRATION_INTL_D60,
  NAME_ENTRY = PageId.NAME_ENTRY_INTL_D60,
  CERTIFICATE = PageId.CERTIFICATE_INTL_D60,
  LEARNWORLDS_REDIRECT = PageId.LEARNWORLDS_REDIRECT_INTL_D60,
  REPORT = PageId.REPORT_INTL_D60,
}
